// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from "recoil";

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import AppCredential from "../AppCredential/AppCredential";
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

// Import Recoil
import { activeAutom } from "../../../../recoil-store/recoil-state";

function ButtonItem({ action, variables, setOpenVariable, automId, showAlert, automVersionId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.WHATSAPP.LIST-ITEM.';
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const [outLabel, setOutLabel] = useState({ isOk: false, value: "" });

    const [validation, setValidation] = useState([]);

    useEffect(() => {
        const inputsToValidate = [
            {
                type: "length",
                validation: {
                    operator: "lt",
                    value: 21
                }
            }
        ]
        setValidation(inputsToValidate);
    }, []);

    useEffect(() => {
        if (action.fields?.label) {
            setOutLabel({ isOk: true, value: action.fields.label.value })
        }
    }, [action?.fields?.label?.value])

    const updateLabel = (id, items) => {
        let isDifferentLabel
        const innerUpdateLabel = (id, items) => {
            items.forEach(item => {
                if (item.id === id) {
                    item.fields = action.fields;
                    if (item.label !== action.fields.label.value && (item.label !== undefined || action.fields.label.value)) {
                        item.label = action.fields.label.value;
                        isDifferentLabel = true
                    }
                } else if (item.children) {
                    innerUpdateLabel(id, item.children);
                }
            });
        }
        innerUpdateLabel(id, items)
        return isDifferentLabel
    };

    const handleBlur = () => {
        let fields = action.fields;
        let items = JSON.parse(JSON.stringify(automDetail.items));
        action.fields = JSON.parse(JSON.stringify(fields));
        const isLabelsDifferent = updateLabel(action.id, items);
        if (!isLabelsDifferent) return
        setAutomDetail({ ...automDetail, items: JSON.parse(JSON.stringify(items)) });
    };
    return (
        <div>
            <AppCredential action={action} />
            <div className="form-element">
                {t(label + "LABEL")}
                <TextInput
                    action={action}
                    inputName="label"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    onBlur={handleBlur}
                    fieldType="string"
                    displayName={t(label + "LABEL")}
                    outNewValue={outLabel}
                    limit={40}
                />
            </div>
            <div className="form-element">
                {t(label + 'TITLE')}
                <TextInput action={action} inputName="title" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired={true} validation={validation} fieldType='string'
                    displayName={t(label + 'TITLE')} />
                <small
                    className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.WHATSAPP.BUTTON-ITEM.TITLE-HELPER', { type: 'string' })}</em></small>
            </div>
            <div className="form-element">
                {t(label + 'RESPONSE')}
                <VariablePicker action={action} inputName="set"
                    variables={variables}
                    disabled={action.fields["set"] && action.fields["set"].value}
                    setOpenVariable={setOpenVariable}
                    styles={{ backgroundColor: "white" }}
                    filter="string"
                    //isRequired={outputVariable.is_required}
                    isOutput={true}
                // hideRequired={true}
                />
                {/* <TextInput action={action} inputName="set" variables={variables} disabled={true}
                    setOpenVariable={setOpenVariable} rows={4} fieldType="string" displayName={t(label + 'RESPONSE')} /> */}
            </div>
        </div>
    );
}

export default ButtonItem;
